module.exports = __webpack_public_path__ + "static/media/temperature.90a9b6b5.svg";